export enum RecurringInvoiceStatus {
  All = 'all',
  Active = 'active',
  Failing = 'failing',
  Inactive = 'inactive',
}
